import http from '../request'
export async function manager() {
  return http.get('/mobile/manager')
}